function StopIcon(props)
{
    return(
<svg className={props.class} style={{"width":"75%","height":'75%'}} version="1.1" id="_x32_" viewBox="0 0 512 512">
<g>
	<path class="st0" d="M256,0C114.625,0,0,114.625,0,256c0,141.374,114.625,256,256,256s256-114.626,256-256   C512,114.625,397.375,0,256,0z M224,336h-64V176h64V336z M352,336h-64V176h64V336z"/>
</g>
</svg>
    )
}

export default StopIcon